/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { AbMenuButton } from "abreact/menu/AbMenuButton";
import { AB_ITEM_SEPARATOR } from "abweb/collection/AbItemSeparator";
import * as React from "react";
/**
 * Implementation detail of to the AbBooleanLogicTree component.
 */
export class GroupColumnOptionsMenu extends React.Component {
  render() {
    const className = CssUtils.composeClassNames("ab-booltree-column-control", this.props.className);
    const label = this.props.value === "AND" ? AbReactResources.abBooleanLogicTree_groupMenu_and() : AbReactResources.abBooleanLogicTree_groupMenu_or();
    const oppositeValue = this.props.value === "AND" ? "OR" : "AND";
    const oppositeLabel = this.props.value === "AND" ? AbReactResources.abBooleanLogicTree_columnMenu_changeToOr() : AbReactResources.abBooleanLogicTree_columnMenu_changeToAnd();
    let menuItems = [{
      label: oppositeLabel,
      onClick: () => {
        this.props.onChange(oppositeValue);
      },
      disabled: false,
      dataTestId: this.props.dataTestId ? `${this.props.dataTestId}-and-or-toggle` : "and-or-toggle",
      className: "ab-no-border-button"
    }];
    if (this.props.isOutermostGroup) {
      menuItems = menuItems.concat([AB_ITEM_SEPARATOR, {
        label: AbReactResources.abBooleanLogicTree_menu_deleteAll(),
        onClick: () => this.props.onClearAll?.(),
        disabled: false,
        dataTestId: "delete-all",
        className: "ab-no-border-button"
      }]);
    }
    if (!this.props.isOutermostGroup) {
      menuItems = menuItems.concat([AB_ITEM_SEPARATOR, {
        label: AbReactResources.abBooleanLogicTree_menu_moveUp(),
        onClick: () => this.props.onMoveUp?.(),
        disabled: this.props.isFirstItem,
        dataTestId: "move-subgroup-up",
        className: "ab-no-border-button"
      }, {
        label: AbReactResources.abBooleanLogicTree_menu_moveDown(),
        onClick: () => this.props.onMoveDown?.(),
        disabled: this.props.isLastItem,
        dataTestId: "move-subgroup-down",
        className: "ab-no-border-button"
      }, AB_ITEM_SEPARATOR, {
        label: AbReactResources.abBooleanLogicTree_menu_insertAbove(),
        onClick: () => this.props.onInsertAbove?.(),
        disabled: this.props.isLastItem,
        dataTestId: "insert-above",
        className: "ab-no-border-button"
      }, {
        label: AbReactResources.abBooleanLogicTree_menu_insertBelow(),
        onClick: () => this.props.onInsertBelow?.(),
        disabled: this.props.isLastItem,
        dataTestId: "insert-below",
        className: "ab-no-border-button"
      }]);
    }
    if (this.props.serverSupportsDisabledConditionSection) {
      menuItems = menuItems.concat([AB_ITEM_SEPARATOR, {
        label: AbReactResources.abBooleanLogicTree_menu_enableAllConditions(),
        onClick: () => this.props.onEnableAllConditions?.(),
        disabled: this.props.isFullyEnabled,
        dataTestId: "enable-subgroup",
        className: "ab-no-border-button"
      }, {
        label: AbReactResources.abBooleanLogicTree_menu_disableAllConditions(),
        onClick: () => this.props.onDisableAllConditions?.(),
        disabled: this.props.isFullyDisabled,
        dataTestId: "disable-subgroup",
        className: "ab-no-border-button"
      }]);
    }
    if (!this.props.isOutermostGroup) {
      menuItems = menuItems.concat([AB_ITEM_SEPARATOR, {
        label: AbReactResources.abBooleanLogicTree_menu_deleteSubgroup(),
        onClick: () => this.props.onDeleteGroup?.(),
        dataTestId: "delete-subgroup",
        className: "ab-no-border-button"
      }, {
        label: AbReactResources.abBooleanLogicTree_menu_outdentSubgroup(),
        onClick: () => this.props.onUnfoldGroup?.(),
        dataTestId: "outdent-subgroup",
        className: "ab-no-border-button"
      }]);
    }
    let dataTestId = "group-actions-menu";
    if (this.props.dataTestId) {
      dataTestId = `${this.props.dataTestId}-${dataTestId}`;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      onMouseEnter: () => {
        this.props.onEmphasisChanged(true);
      },
      onMouseLeave: () => {
        this.props.onEmphasisChanged(false);
      }
    }, /*#__PURE__*/React.createElement(AbMenuButton, {
      className: "ab-no-border-button ab-booltree-connective-button",
      label: label,
      icon: "",
      dataTestId: `${dataTestId}-button`,
      disabled: this.props.readonly,
      menuItems: menuItems,
      menuProps: {
        dataTestId
      }
    }));
  }
}
//# sourceMappingURL=GroupColumnOptionsMenu.js.map
